module.exports = __webpack_public_path__ + "img/box-zipcode.776f59c1.png";